module.exports = __webpack_public_path__ + "static/media/login-background.1e599581.jpg";